import classNames from "classnames";
import React from "react";

import { userColors } from "../../constants";

type Props = {
  color?: number;
  value?: string;
};

function UsersCircleAuditTrails({ value, color }: Props) {
  return (
    <div className={classNames("users users-circle-container")}>
      {/* @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type. */}
      <div className="users-circle" style={{ background: userColors[color] }}>
        {value}
      </div>
    </div>
  );
}

export default UsersCircleAuditTrails;
